import { AlertType, SAlert } from '../../styles/components/Alert';
import { FaCheck, } from "react-icons/fa";
import { CgDanger } from "react-icons/cg";

export type AlertBType = AlertType & {
    message: string,
    iconCheck: boolean,
}

export type AlertAType = AlertBType & {
    setStyle: Function
}
const Alert = ({ message, iconCheck, visibility, opacity, setStyle }: AlertAType) => {

    const close = () => {
        setStyle((e: AlertBType) => ({ ...e, opacity: 0, visibility: 'hidden' }));
    }

    return (
        <SAlert visibility={visibility} opacity={opacity}>
            <article >
                <div className="title">
                    <button onClick={close}>&times;</button>
                </div>
                <div className="content">
                    <span>
                        {iconCheck ? (
                            <FaCheck size={80} color="#68e0cf" />
                        ) :
                            (
                                <CgDanger size={85} color="df4759" />
                            )}
                    </span>

                    <p>
                        {message}
                    </p>

                    <button onClick={close}>Ok</button>
                </div>
            </article>
        </SAlert>
    );
}

export default Alert;